module.exports = __webpack_public_path__ + "static/media/marine_cargo.bc23a467.svg";